import FieldsViewContainer from '../components/field-map/FieldsViewContainer';
import FieldsPreview from '../components/fields-preview/FieldsPreview';

const FieldsPreviewView = () => (
  <FieldsViewContainer>
    <FieldsPreview />
  </FieldsViewContainer>
);

export default FieldsPreviewView;
